// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"ParameterEmpty_spinnerContainer__10-t5","spinner":"ParameterEmpty_spinner__2cCZv","center":"ParameterEmpty_center__2gzod"};